import { InventoryCreationDTO } from "./inventory-creation.dto";
import { ActionInventory } from "./type/action-inventory.enum";

export class ActionInventoryDeleteDTO extends InventoryCreationDTO {
  action!: ActionInventory.delete;
  id!: string;
}
